import './App.css';
import {ToastContainer} from 'react-toastify';
import Form from './component/Form';

function App() {
  return (
    <div className="layer-form">
      <Form />
      <ToastContainer />
    </div>
  );
}

export default App;
